import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-20 bg-slate-900 border-t border-slate-800" data-id="element-56">
      <div className="container mx-auto px-4 text-center max-w-4xl" data-id="element-57">
        <div className="mb-10" data-id="element-58">
          <p className="text-red-400 font-bold uppercase tracking-wider mb-4" data-id="element-59">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown theme="danger" className="scale-110" data-id="element-60" />
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-61">
          <div className="min-w-[600px] max-w-3xl mx-auto" data-id="element-62">
            <div className="grid grid-cols-3 gap-4 mb-4 px-4 items-end" data-id="element-63">
              <div data-id="element-64"></div>
              <div className="font-bold text-slate-400 uppercase text-sm tracking-wider text-center" data-id="element-65">
                🏆 MEGAPACK 360
              </div>
              <div className="font-bold text-slate-200 uppercase text-sm tracking-wider text-center flex items-center justify-center gap-1" data-id="element-66">
                ⭐ MEGAPACK + PACK MAESTRO AVANZADO
              </div>
            </div>

            <div className="space-y-2" data-id="element-67">
              <div className="grid grid-cols-3 gap-4 bg-slate-950/60 rounded-xl p-4 items-center border border-slate-800" data-id="element-68">
                <div className="text-slate-400 font-medium text-sm" data-id="element-69">
                  Contenido
                </div>
                <div className="text-white font-medium text-center" data-id="element-70">
                  4 tomos + 4 bonos
                </div>
                <div className="text-slate-200 font-bold text-center" data-id="element-71">
                  4 tomos + 4 bonos + banco EASA & FAA
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 bg-slate-950/60 rounded-xl p-4 items-center border border-slate-800" data-id="element-72">
                <div className="text-slate-400 font-medium text-sm" data-id="element-73">Precio</div>
                <div className="text-white font-bold text-center" data-id="element-74">
                  $19.990 ARS
                </div>
                <div className="text-slate-200 font-bold text-center text-lg" data-id="element-75">
                  $27.990 ARS
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 bg-transparent p-4 items-center" data-id="element-76">
                <div data-id="element-77"></div>
                <div className="text-center" data-id="element-78">
                  <a href="https://www.centralpack.shop/cart/53719987323198:1" target="_blank" rel="noopener noreferrer" data-id="element-79">
                    <Button size="sm" variant="outline" className="w-full text-xs" data-id="element-80">
                      🟡 QUIERO MI MEGAPACK
                    </Button>
                  </a>
                </div>
                <div className="text-center" data-id="element-81">
                  <a href="https://www.centralpack.shop/cart/53719999643966:1" target="_blank" rel="noopener noreferrer" data-id="element-82">
                    <Button size="sm" variant="primary" className="w-full text-xs" data-id="element-83">
                      🟡 LLEVAR PACK MAESTRO
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-slate-300 font-medium" data-id="element-84">
          <div className="flex items-center gap-1.5" data-id="element-85">
            <Lock className="w-4 h-4 text-slate-300" data-id="element-86" />
            <span data-id="element-87">Pago seguro en pesos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-88">
            <Zap className="w-4 h-4 text-slate-300" data-id="element-89" />
            <span data-id="element-90">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-91">
            <Shield className="w-4 h-4 text-slate-300" data-id="element-92" />
            <span data-id="element-93">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-94">
            <CreditCard className="w-4 h-4 text-slate-300" data-id="element-95" />
            <span data-id="element-96">Tarjeta o Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}